<template>
  <div>
      <el-tabs v-model="activeTab" v-if="workOrderData.trial_form.take_trial" type="border-card" tab-position="left">
                <el-tab-pane label="Trial Window" name="1">

                    <el-tabs v-model="trialTab" type="border-card">
                        <el-tab-pane label="Basic" name="1">
                            <div style="width: 100%; diplay: flex; display: flex; flex-direction: row; justify-content: space-between; align-items: space-between;">
                                <div style="text-align: left; display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;">
                                    <div style="margin-top: 20px;">
                                        <span type="label">Trial Date</span>
                                        <br>
                                        <el-date-picker
                                            size="small"
                                            type="date"
                                            v-model="workOrderData.trial_form.trial_done_date"
                                            style="width: 400px;" 
                                            value-format="yyyy-MM-dd"
                                            format="MMM dd yyyy">
                                        </el-date-picker>
                                    </div>
                                    <div v-if="workOrderData.trial_form.take_trial" style="margin-top: 10px;">
                                        <span class="label">Trial Taken By</span>
                                        <br>
                                        <el-select 
                                            size="small"
                                            v-model="workOrderData.trial_form.trial_taken_by_staff_id"
                                            filterable placeholder="Select" style="width: 400px;">
                                            <el-option
                                                v-for="(data, index) in $store.getters.getEmployeeMasterList.filter(t => t.active && t.can_assist_trial)"
                                                :key="index"
                                                :label="data.staff_name"
                                                :value="data.id">
                                                <span style="float: left" v-html="data.staff_name"></span>
                                            </el-option>
                                        </el-select>
                                    </div>
                                    <div v-if="workOrderData.trial_form.take_trial" style="margin-top: 10px;">
                                        <span class="label">Trial Assisted By</span>
                                        <br>
                                        <el-select 
                                            size="small"
                                            v-model="workOrderData.trial_form.trial_assisted_by_staff_id"
                                            filterable placeholder="Select" style="width: 400px;">
                                            <el-option
                                                v-for="(data, index) in $store.getters.getEmployeeMasterList.filter(t => t.active && t.can_assist_trial)"
                                                :key="index"
                                                :label="data.staff_name"
                                                :value="data.id">
                                                <span style="float: left" v-html="data.staff_name"></span>
                                            </el-option>
                                        </el-select>
                                    </div>
                                    <div v-if="workOrderData.trial_form.take_trial" style="margin-top: 10px;">
                                        <span type="label">Trial Notes</span>
                                        <br>
                                        <vue-editor 
                                            style="height: 250px; width: 400px;" 
                                            :editor-toolbar="customToolbar"
                                            v-model="workOrderData.trial_form.trial_notes" />
                                    </div>
                                    <div v-if="workOrderData.trial_form.take_trial" style="margin-top: 70px;">
                                        <span type="label">Customer's Next Visit Date?</span>
                                        <br>
                                        <el-date-picker
                                            size="small"
                                            type="date"
                                            v-model="workOrderData.appointment_date"
                                            style="width: 400px;" 
                                            value-format="yyyy-MM-dd"
                                            format="MMM dd yyyy">
                                        </el-date-picker>
                                    </div>
                                    <div v-if="workOrderData.trial_form.take_trial" style="margin-top: 20px;">
                                        <span type="label">Visit Is For?</span>
                                        <br>
                                        <el-radio @change="toggleProcessList" :label="0" v-model="workOrderData.appointment_type">Delivery</el-radio>
                                        <el-radio :label="1" @change="toggleProcessList" v-model="workOrderData.appointment_type">Re-Trial</el-radio>
                                    </div>

                                    <div style="margin-top: 20px;" v-if="workOrderData.appointment_type === 1">
                                        <span type="label">Trial Type</span>
                                        <br>
                                        <el-select v-model="workOrderData.trial_type_id" size="small" style="width: 400px;">
                                            <el-option
                                                v-for="(data, index) in $store.getters.getTailoringTrialTypeList"
                                                :key="index"
                                                :label="data.trial_type"
                                                :value="data.id">
                                                    <span style="float: left;">
                                                        {{data.trial_type}}
                                                    </span>                               
                                            </el-option>  
                                        </el-select>
                                    </div>
                                    
                                    <div v-if="workOrderData.trial_form.take_trial" style="margin-top: 20px;">
                                        <span type="label">Next Process?</span>
                                        <br>
                                        <el-select 
                                            size="small"
                                            v-model="workOrderData.trial_form.next_process_id"
                                            filterable placeholder="Select" style="width: 400px;">
                                            <el-option
                                                v-for="(data, index) in workOrderData.process_list.filter(t => ((t.is_required && t.hidden_process === -1) || t.hidden_process === 2))"
                                                :key="index"
                                                :label="data.process_name"
                                                :value="data.process_id">
                                                <span style="float: left" v-html="data.process_name"></span>
                                            </el-option>
                                        </el-select>
                                    </div>
                                </div>

                                <div style="display: flex; flex-direction: row; justify-content: flex-start; align-items: flex-start; flex-wrap: wrap;">

                                    <div             
                                        v-for="(data, index) in workOrderData.trial_form.trial_image_list"
                                        :key="index"
                                        style="display: flex; 
                                        flex-direction: column; 
                                        justify-content: center; 
                                        align-items: center;
                                        margin: 20px;">
                                        <div style="width: 200px; height: 200px;">
                                            <UploadFile 
                                                @uploaded="addNewImage(index, $event)"
                                                :image_path="data"
                                                :image_width="200"
                                                :file_dialog_id="'work_order_photo_trial_'+index"
                                                :hide_upload="data.length>5"
                                                :button_style="'width: 100px; top: 5px; position: relative;'"
                                            />
                                        </div>
                                        <el-button @click="removeImage(index)" v-if="data.length>5" size="small" type="danger" style="top: 5px; position: relative;">
                                            Remove
                                        </el-button>

                                    </div>
                
                                </div>

                            </div>
                    
                        </el-tab-pane>
                        <el-tab-pane label="Measurements" name="2">
                            <MeasurementForm 
                                :trial_form="true"
                                :msmt_form="workOrderData.trial_form.measurement_changes"
                                :item_category_id="workOrderData.category_id"
                                :customer_measurement_profile="workOrderData.customer_measurement_profile"
                            />
                        </el-tab-pane>
                    </el-tabs>

                </el-tab-pane>
                <el-tab-pane :disabled="workOrderData.trial_history.length === 0" label="Trial History" name="2">
                    <div 
                        :style="'width: 100%; text-align: left; display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;'">
                        <el-table
                            :data="workOrderData.trial_history"
                            style="width: 100%">
                            <el-table-column 
                            prop="trial_done_date_changed"
                            label="Date">
                            </el-table-column>
                            <el-table-column 
                            prop="trial_taken_by"
                            label="Trial Taken By">
                            </el-table-column>
                            <el-table-column 
                            prop="trial_assisted_by"
                            label="Trial Assisted By">
                            </el-table-column>
                            <el-table-column
                            fixed="right"
                            label=""
                            width="100">
                            <template slot-scope="scope">

                                <a @click="printTrial(scope.row.id)" style="cursor: pointer; margin-left: 10px;">
                                    <i :class="'el-icon-printer'"></i>
                                </a>

                            </template>
                            </el-table-column>
                            </el-table>
                    </div>
                    
                </el-tab-pane>
            </el-tabs>

      <br><br><br>
  </div>
</template>

<script>
import MeasurementForm from '../CustomerMaster/Form/MeasurementProfile/Index.vue'
import StyleList from './StyleList'

export default {
    components: {MeasurementForm, StyleList},
    props: ['workOrderData'],
    data() {
        return {
            customToolbar: [
                [{ list: "ordered" }]
            ],
            activeTab: '1',
            trialTab: '1'
        }
    },
    methods: {
        toggleProcessList() {
            let appointment_type = this.workOrderData.appointment_type
            this.workOrderData.process_list.forEach(element => {
                if(element.hidden_process === 1 && appointment_type === 1) {
                    element.is_required = true
                } else if(element.hidden_process === 2 && appointment_type === 1) {
                    element.is_required = false
                } 
                 
                if(element.hidden_process === 1 && appointment_type === 0) {
                    element.is_required = false
                } else if(element.hidden_process === 2 && appointment_type === 0) {
                    element.is_required = true
                }
            })
        },
        addNewImage(index, $event) {
            this.workOrderData.trial_form.trial_image_list[index] = $event
            this.workOrderData.trial_form.trial_image_list.push("")
        },
        removeImage(index) {
            this.$confirm('Are you sure to remove?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.workOrderData.trial_form.trial_image_list.splice(index, 1)
            }).catch(() => {
                    
            });
        },
        printTrial(trialId) {
            //console.log(JSON.stringify(this.workOrderData))
            this.$emit('printTrial', {trial_id: trialId})
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/WorkOrder/TrialWindow.vue